import React from 'react';

export interface CharacterCounterProps {
  current: number;
  max: number;
  className?: string;
}

/**
 * Character Counter Component
 * Displays current/max character count with visual feedback
 */
const CharacterCounter: React.FC<CharacterCounterProps> = ({ current, max, className = '' }) => {
  return (
    <div className={`flex justify-end text-xs mt-1 ${className}`}>
      <span className="font-medium">
        {current}/{max}
      </span>
    </div>
  );
};

export default CharacterCounter;
